<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
  <div class="d-flex align-items-center">
    <button
      class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block"
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#companyModal"
      style="background-color: #EB9355; justify-content: center;"
      @click="initField"
      v-if="current_permissions('create_user', 'edit_user')"
    >
      {{ $t('users.createUser') }}
      <i class="flaticon-plus position-relative ms-5 fs-12"></i>
    </button>
  </div>
  <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
    <input
      v-model="searchQuery"
      type="text"
      class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
      :placeholder="$t('users.search')"
    />
  </div>
</div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('users.id') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.name') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.email') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.role') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.type') }}
              </th> 
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('users.validator') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user) in paginatedUsers" :key="user.code">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="form-check mb-0">
                    <input class="form-check-input shadow-none" type="checkbox" />
                  </div>
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ user.code}}
                  </div>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ user.name}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ user.organization.name}}
              </td>              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ user.email}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ user.role}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ user.type}}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="user.status==='ACTIVE'">{{ $t('users.active') }}</span>
                <span class="badge text-outline-danger" v-if="user.status==='INACTIVE'">{{ $t('users.inactive') }}</span>                
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span class="badge text-outline-success" v-if="user.isPayoutValidator===true">{{ $t('users.yes') }}</span>
                <span class="badge text-outline-danger" v-if="user.isPayoutValidator===false">{{ $t('users.no') }}</span>                
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown" v-if="canManageUser(user.role)">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showUser(user.code)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        {{ $t('users.edit') }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="activeValidation(user.isPayoutValidator,user.code)">
                        <i class="flaticon-logout lh-1 me-8 position-relative top-1"></i>
                        <span v-if="user.isPayoutValidator===false">{{ $t('users.activateValidator') }}</span>
                        <span v-if="user.isPayoutValidator===true">{{ $t('users.deactivateValidator') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="changeStatus(user.status,user.code)">
                        <i class="flaticon-logout lh-1 me-8 position-relative top-1"></i>
                        <span v-if="user.status==='ACTIVE'">{{ $t('users.deactivate') }}</span>
                        <span v-if="user.status==='INACTIVE'">{{ $t('users.activate') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="getPermissionByUser(user.code)">
                        <span class="" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                          <i class="flaticon-logout lh-1 me-8 position-relative top-1"></i>
                          {{ $t('users.permission') }}
                        </span>
                      </a>
                    </li>
                    <!-- Générer mot de passe (uniquement pour les utilisateurs API) -->
                    <li v-if="user.type === 'API'">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="generatePasswordForUser(user.code)">
                        <i class="flaticon-logout lh-1 me-8 position-relative top-1"></i>
                        {{ $t('users.generatePassword') }}
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card-footer">
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-3 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('users.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('users.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('users.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('users.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('users.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('users.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination flex-nowrap mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage }}</a>
              <a v-else class="page-link" href="#" @click.prevent="goToPage(numPage)">{{ numPage }}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Offcanvas Permission (REDESIGNÉ : plus de dropdown avec input imbriqué -> fini les chevauchements) -->
  <div class="offcanvas offcanvas-end permission-offcanvas" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header border-bottom">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel">{{ $t('users.permissionManagement') }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <ul class="nav nav-pills gap-2 flex-nowrap overflow-auto text-nowrap mb-20 pb-5">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tabsPermission === '1' }" @click="selectedTabsPermission('1')" href="javascript:void(0)">{{ $t('users.list') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tabsPermission === '2' }" @click="selectedTabsPermission('2')" href="javascript:void(0)">{{ $t('users.assign') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: tabsPermission === '3' }" @click="selectedTabsPermission('3')" href="javascript:void(0)">{{ $t('users.restore') }}</a>
        </li>
      </ul>

      <!-- Onglet 1 : Liste -->
      <div v-if="tabsPermission === '1'">
        <div v-if="permissionByUser.length === 0" class="text-muted text-center py-30">
          {{ $t('users.no') }}
        </div>
        <div
          v-for="(permission) in permissionByUser"
          :key="permission.code"
          class="permission-row d-flex align-items-center justify-content-between gap-10 py-12 px-10 mb-8 rounded-2"
        >
          <div class="min-w-0">
            <div class="fw-semibold text-black text-truncate">{{ permission.name }}</div>
            <div class="fs-12 text-body-tertiary text-truncate">{{ permission.code }}</div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger flex-shrink-0"
            @click="openRevokeModal(permission)"
          >
            {{ $t('users.revoke') }}
          </button>
        </div>
      </div>

      <!-- Onglet 2 : Attribution -->
      <div v-if="tabsPermission === '2'">
        <form @submit.prevent="saveAttributePermission">
          <div v-if="errors!==''" class="mb-15">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>
          <div v-if="success!==''" class="mb-15">
            <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
          </div>

          <label class="d-block text-black fw-semibold mb-10">{{ $t('users.availablePermissions') }}</label>
          <div class="row g-2 mb-15">
            <div v-for="permission in permnissionsArrayTemp" :key="permission.code" class="form-check col-12 col-sm-6">
              <input
                class="form-check-input"
                type="checkbox"
                :id="'permission-' + permission.code"
                :value="permission.code"
                v-model="selectedPermissions"
                :disabled="hasPermission(permission.code)"
              />
              <label class="form-check-label text-black" :for="'permission-' + permission.code">
                {{ permission.name }}
              </label>
            </div>
          </div>

          <button type="submit" class="btn text-white w-100" style="background-color: #EB9355;" v-if="current_permissions('grant_permission')" :disabled="btnLoad">
            <span v-if="btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <i v-if="!btnLoad" class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i> 
            {{ $t('users.save') }}
          </button>
        </form>
      </div>

      <!-- Onglet 3 : Restauration -->
      <div v-if="tabsPermission === '3'">
        <div v-if="permissionsArrayRevokedTemp.length === 0" class="text-muted text-center py-30">
          {{ $t('users.no') }}
        </div>
        <div
          v-for="(permissionRevoked) in permissionsArrayRevokedTemp"
          :key="permissionRevoked.permission?.code"
          class="permission-row d-flex align-items-center justify-content-between gap-10 py-12 px-10 mb-8 rounded-2"
        >
          <div class="min-w-0">
            <div class="fw-semibold text-black text-truncate">{{ permissionRevoked.permission?.name || 'N/A' }}</div>
            <div class="fs-12 text-body-tertiary text-truncate">{{ permissionRevoked.reason }}</div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-success flex-shrink-0"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
            @click="showConfirmRestorePermission(permissionRevoked.user?.code, permissionRevoked.permission?.code)"
          >
            {{ $t('users.restore') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Révocation de permission (remplace l'ancien input imbriqué dans le dropdown) -->
  <div class="modal fade" id="revokePermissionModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('users.revoke') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="fw-semibold text-black mb-15">{{ permissionToRevokeName }}</p>
          <label class="d-block text-black fw-semibold mb-10">{{ $t('users.revokeReason') }}</label>
          <input
            v-model="formValues.revoke_reason"
            type="text"
            class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
            :placeholder="$t('users.revokeReason')"
          />
          <div v-if="revoquePermissionError" class="text-red fw-bold mt-10 text-center" style="color: red;">
            {{ revoquePermissionError }}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-dark" data-bs-dismiss="modal">{{ $t('users.no') }}</button>
          <button type="button" class="btn text-white" style="background-color: #EB9355;" @click="revoquePermission(permissionToRevokeCode, userCode)">
            {{ $t('users.yes') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit User -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">     
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('users.create') : $t('users.edit') }} {{ $t('users.user') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">                        
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.fullName') }}</label>
                  <div>
                    <input v-model="formValues.name" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('users.fullNamePlaceholder')" @blur="validate('name')" @keyup="validate('name')" :class="{ 'is-invalid': errorsBis['name'] }" :readonly="!canEditRestrictedFields" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span> 
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.email') }}</label>
                  <div>
                    <input v-model="formValues.email" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('users.emailPlaceholder')" @blur="validate('email')" @keyup="validate('email')" :class="{ 'is-invalid': errorsBis['email'] }" :readonly="!canEditRestrictedFields" />
                    <span class="invalid-feedback">{{ errorsBis['email']}}</span> 
                  </div>
                </div>
              </div>

              <!-- Organisation :
                   - En CRÉATION (edit===0), si le rôle choisi est SUPERADMIN / BUSINESS / SUPPORT,
                     on affiche un <select> chargé depuis /secure/organizations/ pour choisir
                     l'organisation dans laquelle créer l'utilisateur.
                   - Dans tous les autres cas (rôle "normal" en création, ou modification, quel
                     que soit le rôle), on affiche uniquement le NOM de l'organisation en lecture
                     seule (jamais modifiable, même par le SuperAdmin, en édition). -->
              <div class="row g-3 mt-1">
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.organization') }}</label>
                  <div>
                    <select
                      v-if="canChooseOrganization"
                      name="organization"
                      id="organization"
                      class="form-select fs-md-15 text-black shadow-none"
                      v-model="formValues.organization_code"
                      @change="handleOrganizationChange"
                      required
                    >
                      <option value="">{{ $t('users.select') }}</option>
                      <option v-for="org in organizationsList" :key="org.code" :value="org.code">
                        {{ org.name }}
                      </option>
                    </select>
                    <input
                      v-else
                      v-model="organizationName"
                      type="text"
                      class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
                      readonly
                    />
                  </div>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-6 col-md-3">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.type') }}</label>
                  <div>
                    <select name="type" id="type" class="form-select fs-md-15 text-black shadow-none" v-model="selectedType" @change="handleTypeChange" :disabled="!canEditRestrictedFields" required>
                      <option value="">{{ $t('users.select') }}</option>
                      <option value="WEB">WEB</option>
                      <option value="API">API</option>
                    </select>   
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.role') }}</label>
                  <div>
                    <select name="role" id="role" class="form-select fs-md-15 text-black shadow-none" v-model="selectedRole" @change="handleRoleChange" :disabled="!canEditRestrictedFields" required>
                      <option value="">{{ $t('users.select') }}</option> 
                      <option v-for="role in filteredRoles" :key="role" :value="role">
                        {{ role }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.status') }}</label>
                  <div>
                    <select name="status" id="status" class="form-select fs-md-15 text-black shadow-none" v-model="selectedValidation" @change="handleValidationChange" required>
                      <option value="INACTIVE">{{ $t('users.inactive') }}</option>   
                      <option value="ACTIVE">{{ $t('users.active') }}</option>                                      
                    </select>
                  </div>
                </div>
              </div>
              <div class="row g-3 mt-1" id="web" v-if="zonePassword==1">
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.password') }}</label>
                  <div>
                    <input v-model="formValues.password" type="password" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="***********" @blur="validate('password')" @keyup="validate('password')" :class="{ 'is-invalid': errorsBis['password'] }" />
                    <span class="invalid-feedback">{{ errorsBis['password']}}</span> 
                  </div>  
                </div>
                <div class="col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.confirmPassword') }}</label>
                  <div>
                    <input v-model="formValues.confirm_password" type="password" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" placeholder="***********" @blur="validate('confirm_password')" @keyup="validate('confirm_password')" :class="{ 'is-invalid': errorsBis['confirm_password'] }" />
                    <span class="invalid-feedback">{{ errorsBis['confirm_password']}}</span> 
                  </div>
                </div>
              </div>
              <div class="row g-3 mt-1 align-items-end" id="api" v-if="zonePassword==2 && edit==0">
                <div class="col-9 col-md-11" v-if="result==1">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('users.password') }}</label>
                  <div class="row form-control shadow-none d-flex flex-row align-items-center mx-0">
                    <input type="password" class="col fw-medium text-black fs-md-15 fs-lg-16 mdp text-center border-0" v-model="link" id="link" readonly />   
                    <div class="col-auto ps-0" id="password-hidden">
                      <i class="flaticon-view" v-if="check" id="togglePassword" @click="togglePassword"></i>
                      <i class="flaticon-eye-1" v-if="!check" id="togglePassword" @click="togglePassword"></i>
                    </div>
                  </div>
                </div>
                <div class="col-3 col-md-1" v-if="result==1">
                  <a href="#" class="text-decoration-none d-block text-center" @click="copyToCliboard">                  
                    <i class="flaticon-draft fs-6" style="color: #000"></i>                                  
                  </a>        
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white w-100 w-sm-auto" style="background-color: #EB9355;" v-if="current_permissions('create_user', 'edit_user')">
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i> 
              {{ $t('users.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal confirm restore -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel"></h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center">
          <h4 class="text-black fw-bold mb-0 text-center">
            {{ $t('users.confirmRestore') }}
          </h4>
        </div>
        <div class="modal-footer text-center">
          <button type="button" class="btn btn-outline-dark" data-bs-dismiss="modal">{{ $t('users.no') }}</button>
          <button type="button" class="btn btn-none text-white" style="background-color: #EB9355;" @click="restorePermission(permissionRevokedUserCode,permissionRevokedPermissionCode)">
            {{ $t('users.yes') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Générer mot de passe (utilisateur API existant) -->
  <div class="modal fade" id="generatePasswordModal" tabindex="-1" aria-labelledby="generatePasswordModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="generatePasswordModalLabel">{{ $t('users.generatedPassword') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label class="d-block text-black fw-semibold mb-10">{{ $t('users.password') }}</label>
          <div class="row form-control shadow-none d-flex flex-row align-items-center mx-0">
            <input
              type="password"
              class="col fw-medium text-black fs-md-15 fs-lg-16 mdp-generated text-center border-0"
              v-model="generatedPassword"
              id="generatedPasswordInput"
              readonly
            />
            <div class="col-auto ps-0" id="password-hidden-generated">
              <i class="flaticon-view" v-if="checkGenerated" id="toggleGeneratedPassword" @click="toggleGeneratedPassword"></i>
              <i class="flaticon-eye-1" v-if="!checkGenerated" id="toggleGeneratedPassword" @click="toggleGeneratedPassword"></i>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn text-white w-100 w-sm-auto" style="background-color: #EB9355;" @click="copyGeneratedPassword">
            <i class="flaticon-draft fs-6 me-5" style="color: #FFF;"></i>
            {{ $t('users.copyPaste') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import { Modal } from "bootstrap";
import { useRoute, useRouter } from 'vue-router'
import conf from '../../../../env.json'
import router from '../../../router/index'
import { useI18n } from "vue-i18n";
import { showToast, checkSessionValidate } from "../../../utils/function";
import { current_permissions } from '../../../utils/permission';
import { Actions, Permissions, PermissionsArray, PermissionsRevokedArray, User } from "@/utils/Model";
import * as yup from 'yup';
import ZIndex from "@/components/Utilities/ZIndex/ZIndex.vue";
import { useFixedDropdowns } from "@/utils/useFixedDropdowns";
import { useTableFilter } from "../../../utils/UseTablefilter";

const backApi = inject('back');
const selectedValidation = ref('ACTIVE');
const selectedRole = ref('');
const selectedType = ref('');
const type = ref('');
const role = ref('');
const edit = ref(0);
let itemCode = '';
const errors = ref('');  
const success = ref('');
const errorId = ref('');
const errorsBis = { 'name': '', 'email': '', 'password': '', 'confirm_password': '' };
const pageLoad = ref(false);
const { locale, t } = useI18n();
let result = ref(0);    
let link = ref('');
let zonePassword = 1;
const check = ref(true);
let userCode = ref('')
let userCodeSelect = ref('')
let actionsTemp = new Array<Actions>();
let permnissionsArrayTemp = new Array<PermissionsArray>();
const permissionsArrayRevokedTemp = ref(new Array<PermissionsRevokedArray>());

const selectedPermissions = ref<Permissions[]>([])
const selectedActions = ref([]);

let btnLoad = ref(false)
let permissionRevokedUserCode = ref('')
let permissionRevokedPermissionCode = ref('')

const permissionToRevokeCode = ref('')
const permissionToRevokeName = ref('')

let tabsPermission = ref('1')

let revoquePermissionError = ref('')

const generatedPassword = ref('');
const checkGenerated = ref(true);

const editingUserRole = ref('');

const organizationName = ref('');

// Liste des organisations (pour le select disponible uniquement à la création,
// quand le rôle sélectionné est SUPERADMIN / BUSINESS / SUPPORT).
const organizationsList = ref<any[]>([]);

// Le select d'organisation n'est affiché qu'à la CRÉATION (edit.value === 0)
// et seulement si l'utilisateur CONNECTÉ (celui qui crée) est SUPERADMIN,
// BUSINESS ou SUPPORT (isAuthorizedRole) — indépendamment du rôle attribué
// au nouvel utilisateur. En modification, on affiche toujours uniquement
// le nom en lecture seule.
const canChooseOrganization = computed(() => {
  return edit.value === 0 && isAuthorizedRole.value;
});

useFixedDropdowns();

const ROLE_HIERARCHY = [
  'SUPERADMIN',
  'BUSINESS',
  'SUPPORT',
  'ADMIN',
  'USER',
  'USER_READ_ONLY'
]
const currentUserRole = localStorage.getItem('role')
const currentUserCode = localStorage.getItem('code')
const getRoleIndex = (role) => ROLE_HIERARCHY.indexOf(role)

const token = localStorage.getItem('login_token');
role.value = localStorage.getItem('role');

const currentRole = localStorage.getItem('role');
const isAuthorizedRole = computed(() => {
  return currentRole === 'SUPERADMIN' || currentRole === 'BUSINESS' || currentRole === 'SUPPORT';
});


const canManageUser = (targetRole: string) => {
  if (currentUserRole === 'SUPERADMIN') {
    return true
  }
  const currentIndex = getRoleIndex(currentUserRole)
  const targetIndex = getRoleIndex(targetRole)
  if (currentIndex === -1 || targetIndex === -1) return false
  return targetIndex > currentIndex 
}

const filteredRoles = computed(() => {
  if (currentUserRole === 'SUPERADMIN') {
    return ROLE_HIERARCHY
  }
  const currentIndex = getRoleIndex(currentUserRole)
  if (currentIndex === -1) return []
  return ROLE_HIERARCHY.slice(currentIndex + 1)
})

const canEditRestrictedFields = computed(() => {
  return edit.value === 0 || canManageUser(editingUserRole.value);
});

const urlUsers = computed(() => {
  if (isAuthorizedRole.value) {
    return backApi + '/secure/users/extended';
  } else {
    return backApi + '/secure/users';
  }
});

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleRoleChange(event) {
  selectedRole.value = event.target.value;
  // Le rôle attribué au nouvel utilisateur n'a plus d'incidence sur
  // l'affichage du champ organisation : c'est uniquement le rôle de
  // l'utilisateur CONNECTÉ qui détermine si le select apparaît
  // (cf. canChooseOrganization).
}

function handleOrganizationChange(event) {
  formValues.organization_code = event.target.value;
  organizationName.value = getOrganizationNameByCode(formValues.organization_code);
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
  if (selectedType.value === 'WEB') {
    zonePassword = 1
  } else {
    zonePassword = 2
  }
}

const users = ref(new Array<User>());

// Recherche + pagination front-end (15 par page) via le composable global.
const statusLabelOf = (status: string) =>
  status === 'ACTIVE' ? t('users.active')
  : status === 'INACTIVE' ? t('users.inactive')
  : '';

const validatorLabelOf = (isValidator: boolean) =>
  isValidator === true ? t('users.yes')
  : isValidator === false ? t('users.no')
  : '';

const {
  searchQuery,
  paginatedData: paginatedUsers,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  users,
  [
    (u: any) => u.code,
    (u: any) => u.name,
    (u: any) => u.organization?.name,
    (u: any) => u.email,
    (u: any) => u.role,
    (u: any) => u.type,
    (u: any) => statusLabelOf(u.status),
    (u: any) => validatorLabelOf(u.isPayoutValidator),
  ],
  15
);

const selectedTabsPermission = (event) => {
  getPermissionByUser(userCode.value)
  if (event === '1') {
    tabsPermission.value = '1'
  } else if (event === '2') {
    tabsPermission.value = '2'
    selectedPermissions.value = [];
  } else {
    getPermissionsRevoked(userCode.value)
    tabsPermission.value = '3'
  }
}

// AJOUTÉ: ouvre le modal de révocation pour une permission donnée
const openRevokeModal = (permission) => {
  revoquePermissionError.value = ''
  formValues.revoke_reason = ''
  permissionToRevokeCode.value = permission.code
  permissionToRevokeName.value = permission.name
  const modalEl = document.getElementById('revokePermissionModal');
  const modalInstance = Modal.getOrCreateInstance(modalEl);
  modalInstance.show();
}

const getOrganizationNameByCode = (orgCode) => {
  if (!orgCode) return ''
  const foundInOrgs = organizationsList.value.find(o => o.code === orgCode)
  if (foundInOrgs?.name) return foundInOrgs.name
  const found = users.value.find(u => u.organization?.code === orgCode)
  if (found?.organization?.name) return found.organization.name
  return localStorage.getItem('organization_name') || orgCode
}

const initField = () => {
  formValues.name = '';
  formValues.password = '';
  formValues.email = '';
  formValues.confirm_password = '';
  formValues.organization_code = code;
  organizationName.value = getOrganizationNameByCode(code);
  selectedValidation.value = '';
  selectedRole.value = '';
  selectedType.value = '';
  itemCode = '';
  edit.value = 0;
  zonePassword = 1;
  result.value = 0;
  editingUserRole.value = '';
}

function copyToCliboard() {
  var copyText = document.getElementById("link");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

const generatePassword = (userCode) => {
  try {
    axios.post(`${backApi}/secure/users/generate-password`, {
      user: userCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        link.value = response.data.plainPassword
        result.value = 1;
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const generatePasswordForUser = (userCode) => {
  const targetUser = users.value.find(u => u.code === userCode);
  if (targetUser && !canManageUser(targetUser.role)) {
    showToast("Vous n'avez pas les droits pour cet utilisateur", "red");
    return;
  }
  axios.post(`${backApi}/secure/users/generate-password`, {
    user: userCode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then((response) => {
    if (response.status === 200) {
      generatedPassword.value = response.data.plainPassword;
      checkGenerated.value = true;
      const modalEl = document.getElementById('generatePasswordModal');
      const modalInstance = Modal.getOrCreateInstance(modalEl);
      modalInstance.show();
    }
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        showToast(error.response.data.message, "red");
      }
    }
  });
}

const toggleGeneratedPassword = () => {
  let mdps = document.querySelectorAll('.mdp-generated');
  mdps.forEach(mdp => {
    if (mdp.type == 'password') {
      mdp.type = 'text'
      checkGenerated.value = false;
    } else {
      mdp.type = 'password'
      checkGenerated.value = true;
    }
  });
}

const copyGeneratedPassword = () => {
  const copyText = document.getElementById("generatedPasswordInput");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

const save = () => {
  if (edit.value == 0) {
    storeUser()
  } else {
    updateUser()
  }
}

const saveAttributePermission = () => {
  errorId.value = ''
  errors.value = ''
  success.value = ''
  btnLoad.value = true
  attributePermission()
}

const formValues = reactive({
  name: "",
  email: "",
  password: "",
  confirm_password: "",
  revoke_reason: "",
  organization_code: "",
});

const schema = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
  password: yup.string().required('Le mot de passe est requis').min(6, 'Le mot de passe doit faire au moin 6 caractères'),
  confirm_password: yup.string().required('La confirmation du mot de passe est requis').min(6, 'La confirmation du mot de passe doit faire au moin 6 caractères').oneOf([yup.ref('password'), null], "La confirmation du mot de passe doit être identique au mot de passe")
});

const schemaTypeWEB = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
  password: yup.string().required('Le mot de passe est requis').min(6, 'Le mot de passe doit faire au moin 6 caractères'),
  confirm_password: yup.string().required('La confirmation du mot de passe est requis').min(6, 'La confirmation du mot de passe doit faire au moin 6 caractères').oneOf([yup.ref('password'), null], "La confirmation du mot de passe doit être identique au mot de passe")
});

const schemaTypeAPI = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
});

const leadPlaceholder = "Select Lead Date";
const permissionByUser = ref(new Array<Permissions>());
const permissions = ref(new Array<Permissions>());

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

let code: string | null = '';

onMounted(async () => {
  checkSessionValidate(1)
  flatpickr("#lead-calendar", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    defaultDate: "today",
  });

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });
  const route = useRoute()
  code = localStorage.getItem('organization_code') || route.params.id;

  await getUsers(code);
  await getActions();
  await getPermissions();
  await getOrganizations();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

const fetchUsersPage = (organizationCode: string, targetPage: number) => {
  const baseUrl = isAuthorizedRole.value
    ? `${urlUsers.value}`
    : `${urlUsers.value}/?organization=${organizationCode}`;
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages d'utilisateurs (boucle sur pagination.numPages)
const getUsers = async (organizationCode) => {
  try {
    const first = await fetchUsersPage(organizationCode, 1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchUsersPage(organizationCode, p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    users.value = collected;
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getPermissionByUser = (code) => {
  const targetUser = users.value.find(u => u.code === code);
  if (targetUser && !canManageUser(targetUser.role)) {
    showToast("Vous n'avez pas les droits pour cet utilisateur", "red");
    return;
  }

  errorId.value = ''
  errors.value = ''
  success.value = ''
  tabsPermission.value = '1'
  userCode.value = code
  userCodeSelect.value = code

  axios.get(`${backApi}/secure/permissions/user/${code}/show`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      permissionByUser.value = response.data.allPermissions;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });

  getPermissionsRevoked(userCode.value)
}

const showUser = (userCodeToEdit) => {
  const targetUser = users.value.find(u => u.code === userCodeToEdit);
  if (targetUser && !canManageUser(targetUser.role)) {
    showToast("Vous n'avez pas les droits pour modifier cet utilisateur", "red");
    return;
  }

  axios.get(`${backApi}/secure/users/${userCodeToEdit}/show`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      if (!canManageUser(response.data.role)) {
        showToast("Vous n'avez pas les droits pour modifier cet utilisateur", "red");
        return;
      }
      formValues.name = response.data.name;
      formValues.email = response.data.email;
      formValues.organization_code = response.data.organization?.code ?? code;
      // En modification, on affiche toujours uniquement le NOM de l'organisation
      // (lecture seule) — jamais de select, même pour SUPERADMIN/BUSINESS/SUPPORT.
      organizationName.value = response.data.organization?.name ?? getOrganizationNameByCode(formValues.organization_code);
      selectedValidation.value = response.data.status;
      selectedRole.value = response.data.role;
      selectedType.value = response.data.type;
      zonePassword = response.data.type === 'API' ? 2 : 1;
      itemCode = response.data.code;
      editingUserRole.value = response.data.role;
      edit.value = 1;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const togglePassword = () => {
  let mdps = document.querySelectorAll('.mdp');
  mdps.forEach(mdp => {
    if (mdp.type == 'password') {
      mdp.type = 'text'
      check.value = false;
    } else {
      mdp.type = 'password'
      check.value = true;
    }
  });
}

const storeUser = () => {
  try {
    if (selectedRole.value == '') {
      showToast("Veuillez sélectionner un rôle", "red");
      return;
    }
    // Vérifier que le rôle sélectionné est bien autorisé (par sécurité)
    if (!filteredRoles.value.includes(selectedRole.value)) {
      showToast("Vous ne pouvez pas créer un utilisateur avec ce rôle", "red");
      return;
    }
    if (selectedValidation.value == '') {
      showToast("Veuillez sélectionner un statut", "red");
      return;
    }
    if (selectedType.value == '') {
      showToast("Veuillez sélectionner un type", "red");
      return;
    }
    if (canChooseOrganization.value && !formValues.organization_code) {
      showToast("Veuillez sélectionner une organisation", "red");
      return;
    }

    const payloadStoreUserWEB = {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      email: formValues.email,
      password: formValues.password,
      organization: formValues.organization_code,
      type: selectedType.value,
    }

    const payloadStoreUserAPI = {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      password: null,
      email: formValues.email,
      organization: formValues.organization_code,
      type: selectedType.value,
    }

    let payload = {}
    if (zonePassword == 1) {
      schemaTypeWEB.validateSync(formValues);
      payload = payloadStoreUserWEB
    } else {
      schemaTypeAPI.validateSync(formValues);
      payload = payloadStoreUserAPI
    }

    axios.post(`${backApi}/secure/users/new`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Utilisateur enregistré avec succès", "green");

        setTimeout(() => {
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

const attributePermission = () => {
  try {
    const payload = {
      user: userCodeSelect.value,
      permission: selectedPermissions.value,
      organization: null,
    }
    axios.post(`${backApi}/secure/permissions/grant`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Permission attribué avec succès", "green");
        btnLoad.value = false
        setTimeout(() => {
          zonePassword = 0
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
          btnLoad.value = false
        }
        btnLoad.value = false
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = false
  }
}

const updateUser = () => {
  try {
    if (!canManageUser(editingUserRole.value)) {
      showToast("Vous n'avez pas les droits pour modifier cet utilisateur", "red");
      return;
    }
    if (!filteredRoles.value.includes(selectedRole.value)) {
      showToast("Vous ne pouvez pas attribuer ce rôle à cet utilisateur", "red");
      return;
    }

    if (zonePassword == 1) {
      schemaTypeWEB.validateSync(formValues);
    } else {
      schemaTypeAPI.validateSync(formValues);
    }
    axios.put(`${backApi}/secure/users/${itemCode}/edit`, {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      email: formValues.email,
      password: formValues.password,
      organization: formValues.organization_code,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Utilisaeur modifié avec succès", "green");
        setTimeout(() => {
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  if (zonePassword === 2 && (field === 'password' || field === 'confirm_password')) {
    errorsBis[field] = "";
    return;
  }

  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const fetchActionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/actions/?page=${targetPage}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getActions = async () => {
  try {
    const first = await fetchActionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchActionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    actionsTemp = collected.sort((a, b) => {
      const routeA = a.route ? a.route.toUpperCase() : '';
      const routeB = b.route ? b.route.toUpperCase() : '';
      return routeA.localeCompare(routeB);
    });
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const fetchPermissionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/permissions/?page=${targetPage}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getPermissions = async () => {
  try {
    const first = await fetchPermissionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchPermissionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    permnissionsArrayTemp = collected.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

// Charge TOUTES les pages d'organisations (/secure/organizations/) — même pattern
// que getUsers / getActions / getPermissions — pour alimenter le select affiché
// uniquement à la création d'un utilisateur SUPERADMIN / BUSINESS / SUPPORT.
const fetchOrganizationsPage = (targetPage: number) => {
  const url = `${backApi}/secure/organizations/?page=${targetPage}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getOrganizations = async () => {
  try {
    const first = await fetchOrganizationsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchOrganizationsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    organizationsList.value = collected.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const hasPermission = (permissionCode) => {
  return permissionByUser.value.some(p => p.code === permissionCode);
};

const getPermissionsRevoked = (user) => {
  axios.get(backApi + '/secure/permissions/revoked/?user=' + user, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      const data = response.data;
      const arrayData = Array.isArray(data) ? data : [data];
      permissionsArrayRevokedTemp.value = arrayData.filter(
        (item) => item.disabledAt === null
      );
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  const targetUser = users.value.find(u => u.code === code);
  if (targetUser && !canManageUser(targetUser.role)) {
    showToast("Vous n'avez pas les droits pour cet utilisateur", "red");
    return;
  }

  axios.post(`${backApi}/secure/users/activate`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const revoquePermission = (code, user) => {
  revoquePermissionError.value = ""
  axios.put(`${backApi}/secure/permissions/${code}/revoke`, {
    permission: code,
    organization: null,
    user: user,
    reason: formValues.revoke_reason
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    const modalEl = document.getElementById('revokePermissionModal');
    const modalInstance = Modal.getOrCreateInstance(modalEl);
    modalInstance.hide();
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      revoquePermissionError.value = error.response.data.message;
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const restorePermission = (user, permission) => {
  axios.put(`${backApi}/secure/permissions/${permission}/restore`, {
    permission: permission,
    organization: null,
    user: user
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    permissionRevokedUserCode.value = ''
    permissionRevokedPermissionCode.value = ''
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // router.push('/')
      }
      showToast(error.response.data.message, "red");
    }
  });
}

const showConfirmRestorePermission = (user, permission) => {
  permissionRevokedUserCode.value = user
  permissionRevokedPermissionCode.value = permission
}

const activeValidation = (isPayoutValidator, code) => {
  const targetUser = users.value.find(u => u.code === code);
  if (targetUser && !canManageUser(targetUser.role)) {
    showToast("Vous n'avez pas les droits pour cet utilisateur", "red");
    return;
  }

  axios.post(`${backApi}/secure/users/payout-validator`, {
    code: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}
</script>

<style scoped>
@media (max-width: 767px) {
  .table-responsive table {
    font-size: 13px;
  }
  .default-btn {
    justify-content: center;
  }
  .dropdown-menu {
    max-width: 90vw;
  }
  .pagination .page-link {
    padding: 6px 10px;
    font-size: 13px;
  }
}

@media (max-width: 575px) {
  .offcanvas-end {
    width: 100% !important;
  }
}

@media (min-width: 576px) {
  .w-sm-auto {
    width: auto !important;
  }
}

@media (min-width: 576px) {
  .permission-offcanvas {
    width: 420px !important;
  }
}

.permission-row {
  background-color: #F8F9FA;
  border: 1px solid #EDEDED;
}

.permission-row .min-w-0 {
  min-width: 0;
}

.permission-offcanvas .nav-pills .nav-link {
  background-color: #F1F1F1;
  color: #212529;
}

.permission-offcanvas .nav-pills .nav-link.active {
  background-color: #EB9355;
  color: #fff;
}
</style>